export const PLACEMENT_LABELS = {
  dashboard: 'Dashboard',
  farm_profile: 'Farm Profile',
  pub_good_morning_prairies: 'Good Morning Prairies',
  pub_e_morning_ontario: 'E-Morning Ontario',
  pub_daily_market_wire: 'Daily Market Wire',
  pub_agnews_roundup: 'AgNews Roundup',
  smart_advisor: 'Smart Advisor',
  scenario_planner: 'Scenario Planner',
  roi_calculator: 'ROI Calculator',
};

export const PLACEMENT_OPTIONS = Object.entries(PLACEMENT_LABELS).map(([value, text]) => ({
  text,
  value,
}));

export const LOCATION_OPTIONS = [
  { text: 'All', value: 'ALL' },
  { text: 'Canada', value: 'CA' },
  { text: 'US', value: 'US' },
  { text: 'Other', value: 'OTHER' },
];

export const CTA_TYPES = [
  { text: 'Link', value: 'link' },
  { text: 'Email', value: 'email' },
  { text: 'Phone', value: 'phone' },
];

const CONTENT_NAME_TO_PLACEMENT = {
  'Good Morning Prairies': 'pub_good_morning_prairies',
  'E-Morning Ontario': 'pub_e_morning_ontario',
  'Daily Market Wire': 'pub_daily_market_wire',
};

const CONTENT_IDENTIFIER_TO_PLACEMENT = {
  'ag-news-roundup': 'pub_agnews_roundup',
};

/**
 * Resolves the partner card placement key for a given publication.
 * @param {string} contentName - The Content model name (e.g. "Good Morning Prairies")
 * @param {string} contentIdentifier - The Content model identifier (e.g. "ag-news-roundup")
 * @returns {string|null} Placement key or null if not a supported publication
 */
export function getPlacementForContent(contentName, contentIdentifier) {
  return CONTENT_NAME_TO_PLACEMENT[contentName]
    || CONTENT_IDENTIFIER_TO_PLACEMENT[contentIdentifier]
    || null;
}

export const FIELD_LIMITS = {
  company_name: { min: 1, max: 36 },
  descriptor: { min: 10, max: 50 },
  headline: { min: 50, max: 85 },
  body: { min: 100, max: 250 },
  cta_label: { min: 5, max: 34 },
  cta_value: { max: 500 },
};

export const LOGO_LAYOUT_OPTIONS = [
  { text: 'Rounded', value: 'rounded', icon: 'mdi-circle-outline' },
  { text: 'Square', value: 'square', icon: 'mdi-square-outline' },
  { text: 'Wide', value: 'wide', icon: 'mdi-crop-landscape' },
  { text: 'Tall', value: 'tall', icon: 'mdi-crop-portrait' },
];

export const DEFAULT_LOGO_LAYOUT = 'rounded';
